(function (global) {
  'use strict';

  function readConfig(root) {
    if (root._kcbConfig) return root._kcbConfig;
    var node = root.querySelector('[data-custom-build-config]');
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}'); }
    catch (error) { return {}; }
  }

  function configuratorAnalytics() {
    var intake = global.KindredCustomBuildIntake;
    return intake && intake.analytics && typeof intake.analytics.publish === 'function' ? intake.analytics : null;
  }

  function publishCommerceAnalytics(root, eventName, result, config, options) {
    var analytics = configuratorAnalytics();
    return analytics ? analytics.publish(root, eventName, result, config, options || {}) : Promise.resolve(false);
  }

  function waitForCommerceAnalytics(promise) {
    var analytics = configuratorAnalytics();
    return analytics && typeof analytics.wait === 'function'
      ? analytics.wait(promise, 500)
      : Promise.race([
        Promise.resolve(promise).catch(function () { return false; }),
        new Promise(function (resolve) { global.setTimeout(function () { resolve(false); }, 500); })
      ]);
  }

  function consultationAnalyticsKey(root, config, snapshot) {
    var restoredId = snapshot && concise(snapshot.configurationId);
    var currentId = root && concise(root._kcbConfigurationId);
    var settings = config && config.shopify || {};
    var path = global.location && global.location.pathname || 'current-page';
    return restoredId || currentId || ('generic-' + concise(settings.productId || 'product') + '-' + path);
  }

  function publishConsultationSuccess(root, config, result, snapshot) {
    var analytics = configuratorAnalytics();
    if (!analytics || !analytics.events) return Promise.resolve(false);
    var knownResult = snapshot
      ? (result || root && root._kcbCurrentResult || null)
      : { state: {}, recommendation: {}, estimate: {} };
    var custom = snapshot && knownResult ? requiresConsultation(knownResult) : null;
    var eventContext = {
      purchase_mode: custom === null ? 'consultation_or_review' : (custom ? 'consultation' : 'review')
    };
    if (custom === null) {
      eventContext.requires_consultation = null;
      eventContext.consultation_type = 'configuration_request';
    }
    return publishCommerceAnalytics(root, analytics.events.consultationSent, knownResult, config, {
      key: 'consultation-' + consultationAnalyticsKey(root, config, snapshot),
      persist: true,
      extra: eventContext
    });
  }

  function splitGroups(value) {
    return String(value || '').split('|').map(function (item) { return item.trim(); }).filter(Boolean);
  }

  function valueOverrides(config) {
    var raw = config && config.shopify && config.shopify.giftshipValueOverrides;
    if (!raw) return {};
    if (typeof raw === 'object') return raw;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function displayLabel(group, value) {
    var api = global.KindredCustomBuildIntake;
    return api && api.label ? api.label(group, value) : String(value || '');
  }

  function overrideValue(overrides, key, fallback) {
    var value = overrides[key];
    return typeof value === 'string' && value.trim() ? value.trim() : fallback;
  }

  function overrideFirst(overrides, keys, fallback) {
    var value = fallback;
    (keys || []).some(function (key) {
      var candidate = overrides[key];
      if (typeof candidate !== 'string' || !candidate.trim()) return false;
      value = candidate.trim();
      return true;
    });
    return value;
  }

  function selectedWidth(result) {
    var state = result.state || {};
    var recommendation = result.recommendation || {};
    if (recommendation.isFullCustom) return 'Custom Shape Selected';
    var options = recommendation.widthOptions || [];
    var selected = options.find(function (option) { return option.key === state.waist_width_choice; });
    return selected ? (selected.text || selected.label) : recommendation.width;
  }

  function selectedLength(result) {
    var recommendation = result.recommendation || {};
    if (recommendation.isFullCustom) return 'Custom specification';
    return recommendation.stockLength
      ? String(recommendation.stockLength) + ' cm'
      : String(recommendation.length || '');
  }

  function productFormat(state) {
    var productType = String(state && (state.product_type || state.custom_product_type) || '').toLowerCase();
    if (productType.indexOf('split') !== -1) return 'Splitboard';
    if (productType.indexOf('ski') !== -1) return 'Ski';
    return 'Snowboard';
  }

  function giftshipShapeValue(result, overrides) {
    var state = result.state || {};
    var recommendation = result.recommendation || {};
    var format = productFormat(state);
    var shape = String(recommendation.shape || '').trim();
    var fallback;
    var keys;

    if (recommendation.isFullCustom) {
      fallback = 'KINDRED ' + format + ' Custom Shape';
      keys = [
        'shape.' + state.product_type + '.full_custom',
        'shape.' + state.product_type + '.Custom Shape',
        'shape.full_custom',
        'shape.Custom Shape'
      ];
    } else {
      fallback = 'KINDRED ' + shape + (format === 'Splitboard' ? ' Split' : '');
      keys = [
        'shape.' + state.product_type + '.' + shape,
        'shape.' + shape
      ];
    }

    return overrideFirst(overrides, keys, fallback);
  }

  function signedMillimetres(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    return (number > 0 ? '+' : '') + number + 'mm';
  }

  function giftshipWidthValue(result, overrides) {
    var state = result.state || {};
    var recommendation = result.recommendation || {};
    var key = state.waist_width_choice || 'custom';

    if (recommendation.isFullCustom) {
      return overrideFirst(overrides, [
        'width.full_custom.' + state.product_type,
        'width.full_custom',
        'width.custom'
      ], 'Waist Width: Custom');
    }

    var option = (recommendation.widthOptions || []).find(function (item) { return item.key === key; });
    var adjustment = option && Number(option.adjustment);
    var fallback;

    if (key === 'custom') {
      fallback = 'Custom Width +$100 CAD';
    } else if (option && Number.isFinite(adjustment)) {
      if (adjustment === 0) fallback = 'Standard';
      else if ([-5, -6, -8].indexOf(adjustment) !== -1) fallback = 'Narrow ' + signedMillimetres(adjustment);
      else if (adjustment === 12) fallback = 'Extra Wide ' + signedMillimetres(adjustment);
      else if ([6, 8].indexOf(adjustment) !== -1) fallback = 'Wide ' + signedMillimetres(adjustment);
      else fallback = {
        extra_narrow: 'Waist Width: Narrow',
        narrow: 'Waist Width: Narrow',
        standard: 'Waist Width: Stock',
        wide: 'Waist Width: Wide',
        extra_wide: 'Waist Width: Extra Wide'
      }[key] || 'Waist Width: Stock';
    } else {
      fallback = {
        extra_narrow: 'Waist Width: Narrow',
        narrow: 'Waist Width: Narrow',
        standard: 'Waist Width: Stock',
        wide: 'Waist Width: Wide',
        extra_wide: 'Waist Width: Extra Wide',
        custom: 'Waist Width: Custom'
      }[key] || 'Waist Width: Stock';
    }

    return overrideFirst(overrides, ['width.' + key], fallback);
  }

  function giftshipConstructionValue(state, overrides) {
    var values = {
      fiberglass: 'Construction: Triaxial Fiberglass',
      biaxial_fiberglass: 'Construction: Biaxial Fiberglass',
      triaxial_fiberglass: 'Construction: Triaxial Fiberglass',
      carbon: 'Construction: Carbon Fiber',
      titanal_fiberglass: 'Construction: Fiberglass/Titanal Edge',
      titanal_carbon: 'Construction: Carbon Fiber/Titanal Edge',
      race: 'Construction: Race Construction'
    };
    var fallback = values[state.construction] || ('Construction: ' + displayLabel('construction', state.construction));
    return overrideValue(overrides, 'construction.' + state.construction, fallback);
  }

  function giftshipFlexValue(state, overrides) {
    var fallback = 'Flex Pattern: ' + displayLabel('flex_pattern', state.flex_pattern);
    return overrideValue(overrides, 'flex_pattern.' + state.flex_pattern, fallback);
  }

  function giftshipArtworkValue(state, overrides) {
    var values = {
      custom_marquetry: 'Artwork: Custom Marquetry Topsheet',
      custom_print: 'Artwork: Custom Sublimated Topsheet',
      customer_provided: 'Artwork: Customer Supplied Artwork'
    };

    if (state.artwork_level === 'stock_graphic') {
      var graphic = state.graphic_title || displayLabel('stock_graphic', state.graphic_option);
      return overrideFirst(overrides, [
        'artwork.stock_graphic.' + state.graphic_option,
        'graphic_option.' + state.graphic_option,
        'artwork_level.stock_graphic'
      ], 'Artwork: ' + graphic);
    }

    return overrideFirst(overrides, [
      'artwork.' + state.artwork_level,
      'artwork_level.' + state.artwork_level
    ], values[state.artwork_level] || ('Artwork: ' + displayLabel('artwork_level', state.artwork_level)));
  }

  function giftshipBaseColourValue(state, overrides) {
    var fallback = 'Base: ' + displayLabel('base_colour', state.base_colour);
    return overrideValue(overrides, 'base_colour.' + state.base_colour, fallback);
  }

  function field(property, kind, configuredGroups, value, priced) {
    var groups = splitGroups(configuredGroups);
    if (!groups.length || !value) return null;
    return {
      property: property,
      kind: kind,
      groups: groups,
      value: value,
      required: true,
      priced: Boolean(priced)
    };
  }

  function giftshipFields(result, config) {
    var state = result.state || {};
    var recommendation = result.recommendation || {};
    var settings = config.shopify || {};
    var groups = settings.giftshipGroups || {};
    var overrides = valueOverrides(config);
    var fields = [
      field('Shape', 'Shape', groups.shape,
        giftshipShapeValue(result, overrides), true),
      field('Waist Width', 'Width', groups.width,
        giftshipWidthValue(result, overrides), true),
      field('Construction', 'Construction', groups.construction,
        giftshipConstructionValue(state, overrides), true),
      field('Flex Pattern', 'Flex Profile', groups.flex,
        giftshipFlexValue(state, overrides), true),
      field('Artwork', 'Artwork', groups.artwork,
        giftshipArtworkValue(state, overrides), true)
    ];

    if (state.artwork_level === 'stock_graphic') {
      fields.push(field('Base Colour', 'Base Colour', groups.baseColour,
        giftshipBaseColourValue(state, overrides), true));
    }

    return fields.filter(Boolean);
  }

  function missingGiftshipGroups(result, config) {
    var state = result && result.state || {};
    var groups = config && config.shopify && config.shopify.giftshipGroups || {};
    var required = [
      ['Shape', groups.shape],
      ['Waist width', groups.width],
      ['Construction', groups.construction],
      ['Flex pattern', groups.flex],
      ['Artwork', groups.artwork]
    ];

    if (state.artwork_level === 'stock_graphic') {
      required.push(['Base colour', groups.baseColour]);
    }

    return required.filter(function (entry) {
      return !splitGroups(entry[1]).length;
    }).map(function (entry) { return entry[0]; });
  }

  function concise(value) {
    return String(value === undefined || value === null ? '' : value).trim();
  }

  function riderHeight(state) {
    if (state.unit === 'imperial') {
      return [concise(state.height_feet) && concise(state.height_feet) + ' ft', concise(state.height_inches) && concise(state.height_inches) + ' in'].filter(Boolean).join(' ');
    }
    return concise(state.height) ? concise(state.height) + ' cm' : '';
  }

  function riderWeight(state) {
    return concise(state.weight) ? concise(state.weight) + (state.unit === 'imperial' ? ' lb' : ' kg') : '';
  }

  function stance(state) {
    var parts = [];
    if (state.stance_width) parts.push(state.stance_width + ' ' + (state.stance_width_unit === 'in' ? 'in' : 'cm'));
    if (state.front_angle) parts.push('front ' + state.front_angle + '°');
    if (state.rear_angle) parts.push('rear ' + state.rear_angle + '°');
    return parts.join(' · ');
  }

  function configurationId(root) {
    if (root._kcbConfigurationId) return root._kcbConfigurationId;
    var random = Math.random().toString(36).slice(2, 8).toUpperCase();
    var stamp = new Date().toISOString().replace(/[-:TZ.]/g, '').slice(0, 14);
    root._kcbConfigurationId = 'KCB-' + stamp + '-' + random;
    return root._kcbConfigurationId;
  }

  function requiresConsultation(result) {
    var state = result && result.state || {};
    var recommendation = result && result.recommendation || {};
    var customShape = recommendation.isFullCustom || state.collection === 'custom_shape' || state.custom_shape === 'custom' || state.shape_choice === 'full_custom';
    var customArtwork = Boolean(state.artwork_level) && state.artwork_level !== 'stock_graphic';
    return Boolean(customShape || state.expert_specs || customArtwork);
  }

  function consultationRequestType(result) {
    var state = result && result.state || {};
    var recommendation = result && result.recommendation || {};
    var requests = [];
    if (recommendation.isFullCustom || state.collection === 'custom_shape' || state.custom_shape === 'custom' || state.shape_choice === 'full_custom' || state.expert_specs) requests.push('Custom shape and specifications');
    if (state.artwork_level && state.artwork_level !== 'stock_graphic') requests.push('Graphic customization');
    return requests.length ? requests.join(' + ') : 'Configuration review';
  }

  function consultationBody(root, result) {
    var custom = requiresConsultation(result);
    var summary = concise(result && result.summary);
    var summaryHeading = 'KINDRED CUSTOM BUILD CONFIGURATION';
    var summaryStart = summary.indexOf(summaryHeading);
    if (summaryStart >= 0) summary = summary.slice(summaryStart);
    return [
      'KINDRED CONFIGURATION REQUEST',
      'Request type: ' + consultationRequestType(result),
      'Configuration reference: ' + configurationId(root),
      '',
      custom
        ? 'Please follow up by email to begin the conversation about the requested shape, specifications or graphic customization.'
        : 'Please review this configuration and let the customer know if you recommend any changes.',
      '',
      summary
    ].join('\n');
  }

  function syncPurchaseMode(root, result, config) {
    if (!root || !root.querySelector) return;
    var settings = (config || readConfig(root)).shopify || {};
    var consultation = requiresConsultation(result);
    var purchaseAvailable = Boolean(settings.enabled && settings.productId && settings.variantId && settings.variantAvailable);
    var purchaseButton = root.querySelector('[data-purchase-configuration]');
    var purchaseStatus = root.querySelector('[data-purchase-status]');
    var contactHeading = root.querySelector('[data-contact-heading]');
    var contactIntro = root.querySelector('[data-contact-intro]');
    var consultationButton = root.querySelector('[data-email-configuration]');
    var consultationStatus = root.querySelector('[data-email-status]');
    var phone = root.querySelector('[data-consultation-phone]');
    var phoneRequirement = root.querySelector('[data-phone-requirement]');

    root.classList.toggle('requires-consultation', consultation);
    if (purchaseButton) {
      var busy = purchaseButton.dataset.kindredPurchaseBusy === 'true';
      purchaseButton.disabled = busy || !purchaseAvailable || consultation;
      purchaseButton.setAttribute('aria-disabled', purchaseButton.disabled ? 'true' : 'false');
      if (consultation) purchaseButton.title = 'Custom shapes, specifications and artwork begin with a designer consultation.';
      else purchaseButton.removeAttribute('title');
    }
    if (phone) {
      phone.required = consultation;
      phone.setAttribute('aria-required', consultation ? 'true' : 'false');
    }
    if (phoneRequirement) phoneRequirement.textContent = consultation ? 'required for custom work' : 'optional for stock builds';
    if (contactHeading) contactHeading.textContent = consultation ? 'Begin your designer consultation' : 'Purchase or request a review';
    if (contactIntro) {
      contactIntro.textContent = consultation
        ? 'Custom shapes, specifications and artwork begin with a one-to-one consultation. Send your complete configuration below, and a Kindred designer will follow up by email to begin the conversation about your shape, specifications or graphic customization.'
        : 'Purchase this configuration now, or send the complete rider and build brief to Kindred for review and recommendations.';
    }
    if (consultationButton) {
      consultationButton.textContent = consultation
        ? 'Send Consultation Request →'
        : (consultationButton.getAttribute('data-review-label') || 'Send Configuration to Kindred →');
    }
    if (purchaseStatus) {
      if (consultation) purchaseStatus.textContent = 'Online purchase is unavailable for custom shape, specification or artwork requests. Send this configuration to begin with a Kindred designer.';
      else if (!purchaseAvailable) purchaseStatus.textContent = settings.variantAvailable === false ? 'This product is currently unavailable.' : 'Purchasing is not available from this page.';
      else purchaseStatus.textContent = 'Your selections and configured price will be verified before purchase.';
    }
    if (consultationStatus) {
      consultationStatus.textContent = consultation
        ? 'Email and phone are required. A Kindred designer will follow up by email to begin the customization conversation.'
        : 'Submitting this form sends the complete configuration directly to Kindred for review or recommendations.';
    }
  }

  function addProperty(properties, name, value) {
    var text = concise(value);
    if (!text) return;
    var chunks = [];
    while (text.length > 240) {
      var splitAt = text.lastIndexOf(' ', 240);
      if (splitAt < 120) splitAt = 240;
      chunks.push(text.slice(0, splitAt));
      text = text.slice(splitAt).trim();
    }
    chunks.push(text);
    chunks.forEach(function (chunk, index) {
      properties.push({
        name: chunks.length > 1 ? name + ' ' + (index + 1) : name,
        value: chunk
      });
    });
  }

  function addBuildBrief(properties, value) {
    var text = concise(value);
    if (!text) return;
    var chunks = [];
    while (text.length > 240) {
      chunks.push(text.slice(0, 240));
      text = text.slice(240);
    }
    chunks.push(text);
    chunks.forEach(function (chunk, index) {
      properties.push({
        name: chunks.length > 1 ? '_Kindred Build Brief ' + ('00' + (index + 1)).slice(-3) : '_Kindred Build Brief',
        value: chunk
      });
    });
  }

  function topsheetAssetName(value) {
    var source = concise(value);
    if (!source) return '';
    var filename = source.split(/[?#]/)[0].split('/').pop();
    return /^kindred-[a-z0-9-]+-(?:snowboard|splitboard|skis)-[a-z0-9-]+-topsheet\.webp$/i.test(filename)
      ? filename
      : '';
  }

  function reviewTopsheetAsset(root, result, config) {
    var image = root && root.querySelector
      ? root.querySelector('[data-final-proof]:not([hidden]) [data-proof-topsheet]')
      : null;
    var renderedUrl = image
      ? concise(image.currentSrc || image.src || (image.getAttribute && image.getAttribute('src')))
      : '';
    var renderedAsset = topsheetAssetName(renderedUrl);
    if (renderedAsset) return renderedAsset;

    var intake = global.KindredCustomBuildIntake;
    if (!intake || typeof intake.proofAssets !== 'function' || !result) return '';
    var proof = intake.proofAssets(result.state || {}, result.recommendation || {}, config || {});
    return proof && proof.topsheet ? topsheetAssetName(proof.topsheet) : '';
  }

  function lineItemProperties(root, result, config) {
    var state = result.state || {};
    var recommendation = result.recommendation || {};
    var estimate = result.estimate || {};
    var properties = [];
    var shape = recommendation.isFullCustom ? 'Custom Shape' : recommendation.shape;
    var specs = [
      state.exact_length && 'length ' + state.exact_length + ' cm',
      state.exact_waist && 'waist ' + state.exact_waist + ' mm',
      state.exact_radius && 'radius ' + state.exact_radius + ' m',
      state.exact_taper && 'taper ' + state.exact_taper + ' mm',
      state.exact_tip_length && 'tip ' + state.exact_tip_length + ' mm',
      state.exact_tail_length && 'tail ' + state.exact_tail_length + ' mm',
      state.exact_setback && 'setback ' + state.exact_setback + ' mm',
      state.camber_profile && 'camber ' + displayLabel('camber_profile', state.camber_profile)
    ].filter(Boolean).join(' · ');

    addProperty(properties, '_Kindred Configuration ID', configurationId(root));
    addProperty(properties, '_Kindred Config Version', config.rulesVersion || '2026-09-05');
    addProperty(properties, '_Kindred Cart Image Asset', reviewTopsheetAsset(root, result, config));
    addProperty(properties, '_Kindred Product Type', displayLabel('product_type', state.product_type));
    addProperty(properties, '_Kindred Collection', displayLabel('collection', state.collection));
    addProperty(properties, '_Kindred Shape', shape);
    addProperty(properties, '_Kindred Size', selectedLength(result));
    addProperty(properties, '_Kindred Waist Width', selectedWidth(result));
    addProperty(properties, '_Kindred Construction', displayLabel('construction', state.construction));
    addProperty(properties, '_Kindred Flex Profile', displayLabel('flex_pattern', state.flex_pattern));
    addProperty(properties, '_Kindred Artwork', displayLabel('artwork_level', state.artwork_level));
    if (state.artwork_level === 'stock_graphic') {
      addProperty(properties, '_Kindred Artwork Selection', state.graphic_title || displayLabel('stock_graphic', state.graphic_option));
      addProperty(properties, '_Kindred Base Colour', displayLabel('base_colour', state.base_colour));
    }
    addProperty(properties, '_Kindred Rider', [riderHeight(state), riderWeight(state), state.boot_size && state.boot_size + ' ' + displayLabel('boot_size_unit', state.boot_size_unit), displayLabel('ability', state.ability), displayLabel('location', state.location)].filter(Boolean).join(' · '));
    addProperty(properties, '_Kindred Ride Goals', [displayLabel('terrain', state.terrain), displayLabel('snow', state.snow), displayLabel('turn_style', state.turn_style), displayLabel('ride_feel', state.ride_feel), (state.priorities || []).map(function (item) { return displayLabel('priorities', item); }).join(', ')].filter(Boolean).join(' · '));
    addProperty(properties, '_Kindred Stance', stance(state));
    addProperty(properties, '_Kindred Ski Setup', [state.ski_bsl && state.ski_bsl + ' mm BSL', displayLabel('ski_binding_style', state.ski_binding_style), displayLabel('ski_touring_notch', state.ski_touring_notch)].filter(Boolean).join(' · '));
    if (recommendation.isFullCustom) addProperty(properties, '_Kindred Custom Process', displayLabel('custom_spec_mode', state.custom_spec_mode));
    addProperty(properties, '_Kindred Exact Specs', specs);
    addProperty(properties, '_Kindred Expert Notes', state.expert_notes);
    addProperty(properties, '_Kindred Art Direction', state.art_notes);
    addProperty(properties, '_Kindred Artwork File', state.art_link);
    addProperty(properties, '_Kindred Art Inspiration', state.art_inspiration_link);
    addProperty(properties, '_Kindred Art Reference', state.art_reference_link);
    addProperty(properties, '_Kindred Requested Delivery Date', state.timing);
    addProperty(properties, '_Kindred Build Notes', state.contact_notes);
    addProperty(properties, '_Kindred Configurator Estimate', estimate.total ? estimate.total + ' ' + estimate.currency : '');
    addBuildBrief(properties, result.summary);
    return properties;
  }

  function replaceProperties(form, properties) {
    form.querySelectorAll('[data-kindred-config-property]').forEach(function (input) { input.remove(); });
    (properties || []).forEach(function (property) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + property.name + ']';
      input.value = property.value;
      input.setAttribute('data-kindred-config-property', '');
      form.appendChild(input);
    });
  }

  function clearLegacyHandoffProperties(form) {
    if (!form) return;
    form.querySelectorAll('[data-kindred-handoff]').forEach(function (input) { input.remove(); });
  }

  function variantControl(form) {
    return form && form.querySelector('[name="id"]');
  }

  function setConfiguredVariant(form, variantId) {
    var control = variantControl(form);
    var expected = concise(variantId);
    if (!control || !expected) return false;
    if (concise(control.value) === expected) return true;

    if (control.tagName === 'SELECT') {
      var option = Array.from(control.options || []).find(function (item) {
        return concise(item.value) === expected && !item.disabled;
      });
      if (!option) return false;
      control.value = option.value;
    } else {
      control.value = expected;
    }

    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
    return concise(control.value) === expected;
  }

  function configuredVariantMatches(form, variantId) {
    var control = variantControl(form);
    return Boolean(control && concise(control.value) === concise(variantId));
  }

  function setToolLocked(root, locked) {
    if (locked) {
      if (root._kcbLockedControls) return;
      root._kcbLockedControls = Array.from(root.querySelectorAll('input, select, textarea, button')).map(function (control) {
        var snapshot = { control: control, disabled: control.disabled };
        if (!control.matches('[data-purchase-configuration]')) control.disabled = true;
        return snapshot;
      });
      root.setAttribute('aria-busy', 'true');
      return;
    }

    (root._kcbLockedControls || []).forEach(function (snapshot) {
      if (snapshot.control && snapshot.control.isConnected) snapshot.control.disabled = snapshot.disabled;
    });
    delete root._kcbLockedControls;
    root.removeAttribute('aria-busy');
  }

  function moneyTextToCents(value) {
    var matches = concise(value).match(/-?\d[\d.,]*/g);
    if (!matches || !matches.length) return null;

    var raw = matches[matches.length - 1];
    var comma = raw.lastIndexOf(',');
    var dot = raw.lastIndexOf('.');
    var separator = Math.max(comma, dot);
    var decimal = separator >= 0 && raw.length - separator - 1 === 2;
    var whole = decimal ? raw.slice(0, separator) : raw;
    var fraction = decimal ? raw.slice(separator + 1) : '';
    var normalized = whole.replace(/[.,]/g, '') + (decimal ? '.' + fraction : '');
    var amount = Number(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function selectedGiftshipOptionsTotalCents(context) {
    if (!context || !context.querySelectorAll) return null;
    var controls = Array.from(context.querySelectorAll(
      'select.gs__product-element, select[name="_gs_bundle_ids[]"]'
    ));
    var selectedCount = 0;
    var total = 0;

    for (var controlIndex = 0; controlIndex < controls.length; controlIndex += 1) {
      var options = Array.from(controls[controlIndex].selectedOptions || []).filter(function (option) {
        return concise(option.value);
      });

      for (var optionIndex = 0; optionIndex < options.length; optionIndex += 1) {
        var match = concise(options[optionIndex].textContent).match(/\(([+-])\s*([^()]*)\)\s*$/);
        if (!match) return null;
        var cents = moneyTextToCents(match[2]);
        if (cents === null) return null;
        selectedCount += 1;
        total += match[1] === '-' ? -cents : cents;
      }
    }

    return selectedCount ? total : null;
  }

  function bundleTotalCents(context) {
    if (!context) return null;
    var prices = context.querySelectorAll
      ? Array.from(context.querySelectorAll('[data-product-price][data-giftship-bundle-total], [data-product-price]'))
      : [];
    if (!prices.length && context.querySelector) {
      var price = context.querySelector('[data-product-price][data-giftship-bundle-total], [data-product-price]');
      if (price) prices.push(price);
    }

    var zeroFallback = null;
    for (var priceIndex = 0; priceIndex < prices.length; priceIndex += 1) {
      var rendered = moneyTextToCents(prices[priceIndex].textContent);
      if (rendered !== null && rendered !== 0) return rendered;
      if (rendered === 0) zeroFallback = 0;
    }
    for (var attributeIndex = 0; attributeIndex < prices.length; attributeIndex += 1) {
      var raw = concise(prices[attributeIndex].getAttribute('data-giftship-bundle-total'));
      var attributeCents = null;
      if (/^\d+$/.test(raw)) attributeCents = Number(raw);
      else if (raw) {
        var decimal = Number(raw.replace(/[^0-9.-]+/g, ''));
        if (Number.isFinite(decimal)) attributeCents = Math.round(decimal * 100);
      }
      if (attributeCents !== null && attributeCents !== 0) return attributeCents;
      if (attributeCents === 0) zeroFallback = 0;
    }

    var selectedOptionsTotal = selectedGiftshipOptionsTotalCents(context);
    if (selectedOptionsTotal !== null) return selectedOptionsTotal;
    return zeroFallback;
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) { global.setTimeout(resolve, milliseconds); });
  }

  async function stableBundleTotal(context, expectedCents) {
    var previous = null;
    var stableReads = 0;
    var waitForNonZero = Number(expectedCents) > 0;
    for (var attempt = 0; attempt < 30; attempt += 1) {
      var current = bundleTotalCents(context);
      if (waitForNonZero && current === 0) {
        previous = null;
        stableReads = 0;
        await wait(200);
        continue;
      }
      if (current !== null && current === previous) stableReads += 1;
      else stableReads = 0;
      previous = current;
      if (stableReads >= 2) return current;
      await wait(200);
    }
    return null;
  }

  async function giftshipBridge() {
    for (var attempt = 0; attempt < 40; attempt += 1) {
      if (global.KindredGiftshipHandoff && global.KindredGiftshipHandoff.applyFields) return global.KindredGiftshipHandoff;
      await wait(100);
    }
    return null;
  }

  async function linkedProductTarget(bridge, productId) {
    var form = null;
    var context = null;
    for (var attempt = 0; attempt < 80; attempt += 1) {
      form = bridge && bridge.productForm ? bridge.productForm(productId) : null;
      context = bridge && bridge.productContext ? bridge.productContext(productId) : null;
      if (form && context) return { form: form, context: context };
      await wait(100);
    }
    return { form: form, context: context };
  }

  async function waitForGiftshipOptions(bridge, productId) {
    for (var attempt = 0; attempt < 80; attempt += 1) {
      var form = bridge && bridge.productForm ? bridge.productForm(productId) : null;
      var context = bridge && bridge.productContext ? bridge.productContext(productId) : null;
      if (context && context.querySelector(
        'input.gs__product-element, select.gs__product-element, input[data-child-option], select[data-child-option]'
      )) return { form: form, context: context };
      await wait(100);
    }
    return null;
  }

  function moneyFromCents(cents, currency) {
    try {
      return new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency || 'CAD' }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function currencyCode(value, fallback) {
    var code = concise(value).toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : (fallback || 'CAD');
  }

  function verifyConfiguredPrice(actualCents, result, config) {
    var estimate = result && result.estimate || {};
    var expectedCents = Math.round(Number(estimate.total || 0) * 100);
    var baseCurrency = currencyCode(config && config.baseCurrency, 'CAD');
    var activeCurrency = currencyCode(estimate.currency || config && config.currency, baseCurrency);
    var items = Array.isArray(estimate.items) ? estimate.items.filter(function (item) {
      return Number.isFinite(Number(item && item.amount)) && Number(item.amount) !== 0;
    }) : [];
    var componentCount = Math.max(1, items.length);

    if (!Number.isFinite(actualCents) || actualCents < 0) {
      return { ok: false, reason: 'missing', expectedCents: expectedCents, actualCents: actualCents, toleranceCents: 0, currency: activeCurrency };
    }
    if (!expectedCents) {
      return { ok: false, reason: 'estimate', expectedCents: expectedCents, actualCents: actualCents, toleranceCents: 0, currency: activeCurrency };
    }

    // CAD values are authored in the store's base currency, so Giftship should
    // agree to within two cents. In Shopify Markets, the configurator rounds
    // each converted CAD component to a whole active-currency unit while
    // Giftship retains cents. The maximum legitimate aggregate drift from that
    // difference is 50 cents per priced component, plus the same two-cent
    // synchronization allowance used for CAD.
    var toleranceCents = activeCurrency === baseCurrency ? 2 : (componentCount * 50) + 2;
    var differenceCents = actualCents - expectedCents;
    return {
      ok: Math.abs(differenceCents) <= toleranceCents,
      reason: differenceCents < -toleranceCents ? 'under' : (differenceCents > toleranceCents ? 'over' : 'match'),
      expectedCents: expectedCents,
      actualCents: actualCents,
      differenceCents: differenceCents,
      toleranceCents: toleranceCents,
      currency: activeCurrency,
      baseCurrency: baseCurrency,
      componentCount: componentCount
    };
  }

  function hideNativePurchaseUi(root) {
    var config = readConfig(root);
    var settings = config.shopify || {};
    if (!settings.productId) return;
    var context = document.querySelector('[data-section-type="product"][data-product-id="' + CSS.escape(String(settings.productId)) + '"]');
    if (!context) return;
    var form = context.querySelector('form[action*="/cart/add"]');
    if (!settings.enabled || !settings.hideNativePurchaseUi) {
      if (form && form._kcbPurchaseGuardHandler) {
        form.removeEventListener('submit', form._kcbPurchaseGuardHandler, true);
        delete form._kcbPurchaseGuardHandler;
        delete form._kcbPurchaseGuardRoot;
      }
      context.querySelectorAll('.kcb-native-purchase-hidden').forEach(function (element) {
        element.classList.remove('kcb-native-purchase-hidden');
        element.removeAttribute('aria-hidden');
        element.removeAttribute('tabindex');
      });
      return;
    }
    if (form && form._kcbPurchaseGuardRoot !== root) {
      if (form._kcbPurchaseGuardHandler) form.removeEventListener('submit', form._kcbPurchaseGuardHandler, true);
      form._kcbPurchaseGuardHandler = function (event) {
        if (form._kcbAuthorizedSubmit) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        setMessage(root, 'Complete the configurator and use “Purchase this Configuration” to add this product.', true);
      };
      form._kcbPurchaseGuardRoot = root;
      form.addEventListener('submit', form._kcbPurchaseGuardHandler, true);
    }
    context.querySelectorAll('[data-add-to-cart], .shopify-payment-button').forEach(function (element) {
      element.classList.add('kcb-native-purchase-hidden');
      element.setAttribute('aria-hidden', 'true');
      element.tabIndex = -1;
    });
  }

  function setMessage(root, message, isError) {
    var validation = root.querySelector('[data-purchase-validation]');
    var status = root.querySelector('[data-purchase-status]');
    if (validation) validation.textContent = isError ? message : '';
    if (status) status.textContent = isError ? 'The product was not added to the cart.' : message;
  }

  function setEmailMessage(root, message, isError) {
    var validation = root.querySelector('[data-purchase-validation]');
    var status = root.querySelector('[data-email-status]');
    if (validation) validation.textContent = isError ? message : '';
    if (status) status.textContent = message;
  }

  function consultationStorageKey(root, config) {
    var settings = config && config.shopify || {};
    var productId = settings.productId || root.getAttribute('data-product-id') || 'builder';
    return 'kindred-consultation:' + productId;
  }

  function consultationSnapshot(root) {
    var fields = {};
    var answers = {};
    var contact = {};
    root.querySelectorAll('[data-field]').forEach(function (field) {
      var key = field.getAttribute('data-field');
      if (!key) return;
      fields[key] = field.type === 'checkbox' ? Boolean(field.checked) : String(field.value || '');
    });
    root.querySelectorAll('[data-question-key]').forEach(function (item) {
      var key = item.getAttribute('data-question-key');
      if (!key || Object.prototype.hasOwnProperty.call(answers, key)) return;
      var selected = Array.prototype.map.call(item.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked'), function (input) {
        return String(input.value || '');
      });
      if (selected.length) answers[key] = selected;
    });
    ['contact[name]', 'contact[email]', 'contact[phone]'].forEach(function (name) {
      var field = root.querySelector('[name="' + name + '"]');
      if (field) contact[name] = String(field.value || '');
    });
    return {
      savedAt: Date.now(),
      configurationId: configurationId(root),
      units: root.getAttribute('data-units') || 'metric',
      fields: fields,
      answers: answers,
      contact: contact,
      widthTouched: Boolean(root._kcbWidthTouched),
      flexTouched: Boolean(root._kcbFlexTouched)
    };
  }

  function storeConsultationSnapshot(root, config) {
    try {
      if (global.sessionStorage) global.sessionStorage.setItem(consultationStorageKey(root, config), JSON.stringify(consultationSnapshot(root)));
    } catch (error) { /* The native form still submits when browser storage is unavailable. */ }
  }

  function consultationResult(root) {
    var node = root.querySelector('[data-contact-result]');
    if (!node) return { success: false, errors: false };
    try { return JSON.parse(node.textContent || '{}'); }
    catch (error) { return { success: false, errors: Boolean(root.querySelector('.kcb-form-errors')) }; }
  }

  function restoreConsultationSnapshot(root, config) {
    if (!root || root._kcbConsultationStateRestored || !root._kcbRefresh) return;
    var formResult = consultationResult(root);
    if (!formResult.success && !formResult.errors) return;
    var key = consultationStorageKey(root, config);
    var snapshot;
    try {
      snapshot = global.sessionStorage ? JSON.parse(global.sessionStorage.getItem(key) || 'null') : null;
    } catch (error) { snapshot = null; }
    if (!snapshot || !snapshot.savedAt || Date.now() - snapshot.savedAt > 30 * 60 * 1000) {
      if (formResult.success) publishConsultationSuccess(root, config, root._kcbCurrentResult, null);
      return;
    }
    root._kcbConsultationStateRestored = true;
    if (concise(snapshot.configurationId)) root._kcbConfigurationId = concise(snapshot.configurationId);

    var unitButton = root.querySelector('[data-unit="' + snapshot.units + '"]');
    if (unitButton && root.getAttribute('data-units') !== snapshot.units) unitButton.click();

    function restoreControls() {
      Object.keys(snapshot.fields || {}).forEach(function (fieldKey) {
        var field = Array.from(root.querySelectorAll('[data-field]')).find(function (candidate) {
          return candidate.getAttribute('data-field') === fieldKey;
        });
        if (!field) return;
        if (field.type === 'checkbox') field.checked = Boolean(snapshot.fields[fieldKey]);
        else field.value = snapshot.fields[fieldKey];
      });
      Object.keys(snapshot.answers || {}).forEach(function (questionKey) {
        var item = Array.from(root.querySelectorAll('[data-question-key]')).find(function (candidate) {
          return candidate.getAttribute('data-question-key') === questionKey;
        });
        if (!item) return;
        var selected = snapshot.answers[questionKey] || [];
        item.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
          input.checked = selected.indexOf(String(input.value || '')) !== -1;
        });
      });
      Object.keys(snapshot.contact || {}).forEach(function (name) {
        var field = root.querySelector('[name="' + name + '"]');
        if (field) field.value = snapshot.contact[name];
      });
      root._kcbWidthTouched = Boolean(snapshot.widthTouched);
      root._kcbFlexTouched = Boolean(snapshot.flexTouched);
    }

    for (var pass = 0; pass < 4; pass += 1) {
      restoreControls();
      if (root._kcbRefresh) root._kcbRefresh();
    }
    if (formResult.errors && root._kcbReleasePostedBody) root._kcbReleasePostedBody();
    if (formResult.success) {
      publishConsultationSuccess(root, config, root._kcbCurrentResult, snapshot);
      try { global.sessionStorage.removeItem(key); }
      catch (error) { /* State expiry remains the fallback cleanup. */ }
    }
  }

  function clearConsultationSnapshot(root, config) {
    try { if (global.sessionStorage) global.sessionStorage.removeItem(consultationStorageKey(root, config)); }
    catch (error) { /* Nothing else is required when storage is unavailable. */ }
  }

  function restartAfterContactSuccess(root) {
    if (!consultationResult(root).success || !global.location || !global.location.href) return false;
    try {
      var cleanUrl = new URL(global.location.href);
      cleanUrl.searchParams.delete('contact_posted');
      cleanUrl.hash = '';
      global.location.assign(cleanUrl.toString());
      return true;
    } catch (error) { return false; }
  }

  function prepareConsultationSubmission(form, root) {
    var config = readConfig(root);
    if (!root._kcbValidatePurchase || !root._kcbValidatePurchase()) {
      setEmailMessage(root, 'Please complete every configuration step before sending it to Kindred.', true);
      return false;
    }
    var result = root._kcbRefresh ? root._kcbRefresh() : root._kcbCurrentResult;
    if (!result) {
      setEmailMessage(root, 'The configuration could not be prepared. Please refresh the page.', true);
      return false;
    }
    syncPurchaseMode(root, result, config);

    var requiredFields = [form.querySelector('[name="contact[name]"]'), form.querySelector('[name="contact[email]"]')];
    if (requiresConsultation(result)) requiredFields.push(form.querySelector('[name="contact[phone]"]'));
    var firstInvalid = null;
    var hasInvalid = requiredFields.some(function (field) {
      if (!field) return true;
      var missing = !concise(field.value);
      var invalidValue = typeof field.checkValidity === 'function' && !field.checkValidity();
      field.setAttribute('aria-invalid', missing || invalidValue ? 'true' : 'false');
      if ((missing || invalidValue) && !firstInvalid) firstInvalid = field;
      return missing || invalidValue;
    });
    if (hasInvalid) {
      setEmailMessage(root, 'Please provide your name and email' + (requiresConsultation(result) ? ', plus a phone number for custom work.' : '.'), true);
      if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
      return false;
    }

    var reference = configurationId(root);
    var requestType = form.querySelector('[data-contact-request-type]');
    var referenceField = form.querySelector('[data-contact-reference]');
    var body = form.querySelector('[data-summary-body]');
    if (requestType) requestType.value = consultationRequestType(result);
    if (referenceField) referenceField.value = reference;
    if (body) body.value = consultationBody(root, result);
    storeConsultationSnapshot(root, config);
    setEmailMessage(root, 'Sending your configuration directly to Kindred…', false);
    return true;
  }

  function prepareCommerceBridges() {
    document.querySelectorAll('[data-kindred-commerce-context]').forEach(function (context) {
      context.setAttribute('aria-hidden', 'true');
      context.querySelectorAll('input, select, textarea, button, a[href]').forEach(function (control) {
        control.tabIndex = -1;
      });
    });
  }

  function cartContainsConfiguration(configurationId, config) {
    if (!configurationId || typeof global.fetch !== 'function') return Promise.resolve(false);
    var cartUrl = config && config.shopify && config.shopify.cartUrl || '/cart';
    var jsonUrl = String(cartUrl).replace(/\/$/, '') + '.js';
    var request = global.fetch(jsonUrl, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return false;
      return response.json();
    }).then(function (cart) {
      return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
        var properties = item && item.properties || {};
        return concise(properties['_Kindred Configuration ID']) === configurationId;
      }));
    }).catch(function () { return false; });
    var deadline = new Promise(function (resolve) {
      global.setTimeout(function () { resolve(false); }, 1500);
    });
    return Promise.race([request, deadline]);
  }

  async function waitForConfigurationInCart(configurationId, config) {
    for (var attempt = 0; attempt < 5; attempt += 1) {
      if (await cartContainsConfiguration(configurationId, config)) return true;
      if (attempt < 4) await wait(650);
    }
    return false;
  }

  function submitWithTheme(nativeButton, config, configurationId, onConfirmed) {
    return new Promise(function (resolve, reject) {
      var finished = false;
      var timeout;
      var form = nativeButton.form || nativeButton.closest('form');
      var hadAuthorization = form && Object.prototype.hasOwnProperty.call(form, '_kcbAuthorizedSubmit');
      var previousAuthorization = form && form._kcbAuthorizedSubmit;
      if (form) form._kcbAuthorizedSubmit = true;
      function cleanup() {
        document.removeEventListener('ajaxProduct:added', onAdded);
        document.removeEventListener('ajaxProduct:error', onError);
        global.clearTimeout(timeout);
        if (form) {
          if (hadAuthorization) form._kcbAuthorizedSubmit = previousAuthorization;
          else delete form._kcbAuthorizedSubmit;
        }
      }
      function onAdded(event) {
        if (event.detail && event.detail.addToCartBtn && event.detail.addToCartBtn !== nativeButton) return;
        if (finished) return;
        finished = true;
        cleanup();
        resolve(event.detail || {});
      }
      function onError(event) {
        if (finished) return;
        finished = true;
        cleanup();
        reject(new Error('We could not add this configuration to your cart. Please try again.'));
      }
      document.addEventListener('ajaxProduct:added', onAdded);
      document.addEventListener('ajaxProduct:error', onError);
      timeout = global.setTimeout(function () {
        waitForConfigurationInCart(configurationId, config).then(function (found) {
          if (finished) return;
          finished = true;
          cleanup();
          if (found) resolve({ verifiedByCart: true });
          else {
            var error = new Error('We could not confirm that this configuration was added. Check your cart, then refresh this page before trying again.');
            error.kindredIndeterminate = true;
            reject(error);
          }
        });
      }, 12000);
      nativeButton.click();
    }).then(function (detail) {
      var confirmation;
      try { confirmation = typeof onConfirmed === 'function' ? onConfirmed(detail) : Promise.resolve(false); }
      catch (error) { confirmation = Promise.resolve(false); }
      return waitForCommerceAnalytics(confirmation).then(function () {
        var behavior = config.shopify && config.shopify.postAddBehavior;
        if (behavior === 'cart') global.location.assign((config.shopify && config.shopify.cartUrl) || '/cart');
        if (behavior === 'checkout') global.location.assign('/checkout');
        return detail;
      });
    });
  }

  async function purchase(button, root) {
    if (button.dataset.kindredPurchaseBusy === 'true') return;
    var config = readConfig(root);
    var settings = config.shopify || {};
    var locked = false;
    var keepDisabled = false;
    button.dataset.kindredPurchaseBusy = 'true';
    button.disabled = true;
    setMessage(root, 'Checking your configuration…', false);

    try {
      if (!settings.enabled) throw new Error('Purchasing is currently unavailable. Please send this configuration for assistance.');
      if (!settings.productId || !settings.variantId) throw new Error('Purchasing is not available from this page. Please send this configuration for assistance.');
      if (!settings.variantAvailable) throw new Error('This product is currently unavailable.');
      if (!root._kcbValidatePurchase || !root._kcbValidatePurchase()) throw new Error('Please complete every configuration step before purchasing.');

      var result = root._kcbRefresh ? root._kcbRefresh() : root._kcbCurrentResult;
      if (!result) throw new Error('The configuration could not be prepared. Please refresh the page.');
      if (requiresConsultation(result)) {
        throw new Error('Custom shape, specification and artwork requests begin with a Kindred designer consultation and cannot be purchased online. Send this configuration to begin.');
      }
      var baseCurrency = currencyCode(config.baseCurrency, 'CAD');
      var activeCurrency = currencyCode(result.estimate && result.estimate.currency, baseCurrency);
      if (!settings.allowNonBaseCurrency && activeCurrency !== baseCurrency) {
        throw new Error('Configured checkout is currently available in ' + baseCurrency + ' only. Switch the store currency to ' + baseCurrency + ' to continue.');
      }
      var groupErrors = missingGiftshipGroups(result, config);
      if (settings.requireGiftshipMatches && groupErrors.length) {
        throw new Error('We could not prepare these selections: ' + groupErrors.join(', ') + '. Please try again or send your build for review.');
      }
      setToolLocked(root, true);
      locked = true;
      var bridge = await giftshipBridge();
      if (!bridge) throw new Error('The purchase options did not load. Please refresh the page and try again.');
      var linkedProduct = await linkedProductTarget(bridge, settings.productId);
      var form = linkedProduct.form;
      var context = linkedProduct.context;
      if (!form || !context) throw new Error('Purchasing is temporarily unavailable. Please refresh the page or send this configuration for review.');
      if (!setConfiguredVariant(form, settings.variantId)) {
        throw new Error('The selected product could not be confirmed. Please refresh the page and try again.');
      }
      var giftshipTarget = await waitForGiftshipOptions(bridge, settings.productId);
      if (!giftshipTarget) {
        throw new Error('The purchase options did not load. Please refresh the page and try again.');
      }
      form = giftshipTarget.form || form;
      context = giftshipTarget.context || context;
      if (!setConfiguredVariant(form, settings.variantId)) {
        throw new Error('The selected product could not be confirmed. Please refresh the page and try again.');
      }
      await wait(250);
      form = bridge.productForm(settings.productId) || form;
      context = bridge.productContext(settings.productId) || context;
      if (!configuredVariantMatches(form, settings.variantId)) {
        throw new Error('The selected product could not be confirmed. Please refresh the page and try again.');
      }
      replaceProperties(form, []);
      clearLegacyHandoffProperties(form);
      var fields = giftshipFields(result, config);
      if (!fields.length) throw new Error('Purchase options are not available for this configuration.');

      setMessage(root, 'Preparing and verifying your selections…', false);
      var applied = await bridge.applyFields(fields, {
        productId: settings.productId,
        attachMissing: false,
        showStatus: false,
        scroll: false,
        verify: true
      });
      if (settings.requireGiftshipMatches && (!applied.ok || applied.missing.length || applied.ambiguous.length)) {
        var issues = applied.missing.concat(applied.ambiguous).filter(function (value, index, values) { return values.indexOf(value) === index; });
        throw new Error('Some selections could not be verified: ' + issues.join(', ') + '. Please review your choices and try again.');
      }

      // Required Giftship choices can keep Motion's add button disabled until
      // their change handlers finish. Resolve the current form/button only
      // after those choices are applied, since Giftship may also re-render it.
      form = bridge.productForm(settings.productId) || applied.form;
      var nativeButton = form && form.querySelector('[data-add-to-cart]');
      for (var buttonAttempt = 0; nativeButton && nativeButton.disabled && buttonAttempt < 20; buttonAttempt += 1) {
        await wait(100);
        form = bridge.productForm(settings.productId) || form;
        nativeButton = form.querySelector('[data-add-to-cart]');
      }
      if (!form || !nativeButton || nativeButton.disabled) throw new Error('The linked product cannot currently be added to the cart.');
      if (!configuredVariantMatches(form, settings.variantId)) throw new Error('The selected product changed while your choices were being prepared. Please try again.');
      context = bridge.productContext(settings.productId) || context;

      if (settings.verifyGiftshipTotal) {
        setMessage(root, 'Verifying the configured price…', false);
        var expectedCents = Math.round(Number(result.estimate && result.estimate.total || 0) * 100);
        var actualCents = await stableBundleTotal(context, expectedCents);
        if (actualCents === null) throw new Error('The configured total could not be confirmed. Please try again.');
        var priceCheck = verifyConfiguredPrice(actualCents, result, config);
        if (!priceCheck.ok) {
          var comparison = 'The current purchase total (' + moneyFromCents(actualCents, priceCheck.currency) + ') does not match the estimated total (' + moneyFromCents(priceCheck.expectedCents, priceCheck.currency) + ').';
          if (priceCheck.reason === 'under') comparison = 'The current purchase total (' + moneyFromCents(actualCents, priceCheck.currency) + ') is below the expected range for ' + moneyFromCents(priceCheck.expectedCents, priceCheck.currency) + '.';
          throw new Error(comparison);
        }
      }

      var finalVerification = bridge.verifyFields ? bridge.verifyFields(fields, { productId: settings.productId }) : null;
      if (settings.requireGiftshipMatches && (!finalVerification || !finalVerification.ok)) {
        var finalMissing = finalVerification ? finalVerification.missing.concat(finalVerification.ambiguous) : ['purchase options'];
        var finalIssues = finalMissing.filter(function (value, index, values) { return values.indexOf(value) === index; });
        throw new Error('Your selections changed before checkout could be submitted: ' + finalIssues.join(', ') + '. Please try again.');
      }
      form = finalVerification && finalVerification.form || bridge.productForm(settings.productId) || form;
      nativeButton = form && form.querySelector('[data-add-to-cart]');
      context = bridge.productContext(settings.productId) || context;
      if (!form || !nativeButton || nativeButton.disabled) throw new Error('The linked product cannot currently be added to the cart.');
      if (!configuredVariantMatches(form, settings.variantId)) throw new Error('The selected product could not be confirmed immediately before purchase. Please try again.');
      if (settings.verifyGiftshipTotal) {
        var finalExpectedCents = Math.round(Number(result.estimate && result.estimate.total || 0) * 100);
        var finalActualCents = await stableBundleTotal(context, finalExpectedCents);
        var finalPriceCheck = verifyConfiguredPrice(finalActualCents, result, config);
        if (!finalPriceCheck.ok) throw new Error('The configured price changed before checkout could be submitted. Please try again.');
      }

      clearLegacyHandoffProperties(form);
      var currentConfigurationId = configurationId(root);
      replaceProperties(form, lineItemProperties(root, result, config));
      setMessage(root, 'Adding your configured build to the cart…', false);
      await submitWithTheme(nativeButton, config, currentConfigurationId, function () {
        var analytics = configuratorAnalytics();
        if (!analytics || !analytics.events) return Promise.resolve(false);
        return publishCommerceAnalytics(root, analytics.events.addedToCart, result, config, {
          key: 'cart-' + currentConfigurationId,
          persist: true,
          extra: {
            value: result.estimate && result.estimate.total,
            currency: result.estimate && result.estimate.currency,
            requires_consultation: false,
            purchase_mode: 'online_purchase'
          }
        });
      });
      delete root._kcbConfigurationId;
      setMessage(root, 'Configuration added to cart.', false);
    } catch (error) {
      keepDisabled = Boolean(error && error.kindredIndeterminate);
      setMessage(root, error && error.message ? error.message : 'This configuration could not be added to the cart.', true);
    } finally {
      if (locked) setToolLocked(root, false);
      delete button.dataset.kindredPurchaseBusy;
      if (keepDisabled) button.disabled = true;
      else syncPurchaseMode(root, root._kcbCurrentResult, config);
    }
  }

  function mount(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (context.matches && context.matches('[data-custom-build-intake]')) roots.push(context);
    context.querySelectorAll('[data-custom-build-intake]').forEach(function (root) { roots.push(root); });
    roots.forEach(function (root) {
      var config = readConfig(root);
      hideNativePurchaseUi(root);
      if (!root._kcbPurchaseModeBound) {
        root._kcbPurchaseModeBound = true;
        root.addEventListener('kindred.custombuild.updated', function (event) {
          restoreConsultationSnapshot(root, config);
          syncPurchaseMode(root, root._kcbCurrentResult || event.detail, config);
        });
        root.querySelectorAll('[data-start-over]').forEach(function (button) {
          button.addEventListener('click', function () {
            clearConsultationSnapshot(root, config);
            restartAfterContactSuccess(root);
          });
        });
      }
      restoreConsultationSnapshot(root, config);
      syncPurchaseMode(root, root._kcbCurrentResult, config);
    });
    prepareCommerceBridges();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.kcb-contact-form')) return;
    var root = form.closest('[data-custom-build-intake]');
    if (!root || prepareConsultationSubmission(form, root)) return;
    event.preventDefault();
  });

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target.closest('[data-purchase-configuration]') : null;
    if (!target) return;
    var root = target.closest('[data-custom-build-intake]');
    if (!root) return;
    event.preventDefault();
    purchase(target, root);
  });

  function start() { mount(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('giftship.loaded', start);
  document.addEventListener('giftship.reloaded', start);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });

  global.KindredCustomBuildPurchase = {
    giftshipFields: giftshipFields,
    missingGiftshipGroups: missingGiftshipGroups,
    lineItemProperties: lineItemProperties,
    replaceProperties: replaceProperties,
    clearLegacyHandoffProperties: clearLegacyHandoffProperties,
    selectedGiftshipOptionsTotalCents: selectedGiftshipOptionsTotalCents,
    bundleTotalCents: bundleTotalCents,
    reviewTopsheetAsset: reviewTopsheetAsset,
    stableBundleTotal: stableBundleTotal,
    verifyConfiguredPrice: verifyConfiguredPrice,
    requiresConsultation: requiresConsultation,
    consultationRequestType: consultationRequestType,
    consultationBody: consultationBody,
    syncPurchaseMode: syncPurchaseMode,
    prepareConsultationSubmission: prepareConsultationSubmission,
    restartAfterContactSuccess: restartAfterContactSuccess,
    mount: mount
  };
})(window);
